import * as React from "react"
import Svg, { Path } from "react-native-svg"

function CrossIcon(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            {...props}
        >
            <Path
                d="M9 9.787l-3.938 3.938a.54.54 0 01-.393.169.54.54 0 01-.394-.169.54.54 0 010-.787L8.213 9 4.274 5.062a.54.54 0 01-.169-.393.54.54 0 01.169-.394.54.54 0 01.394-.169.54.54 0 01.394.169L9 8.212l3.938-3.937a.54.54 0 01.787 0 .54.54 0 01.169.394.54.54 0 01-.169.393L9.787 9l3.938 3.938a.54.54 0 01.169.393.54.54 0 01-.169.394.54.54 0 01-.394.169.54.54 0 01-.393-.169L9 9.787z"
                fill="#1D2939"
            />
        </Svg>
    )
}

export default CrossIcon
